/**
 * Requests fullscreen mode for a container element or the document.
 */
export function requestFullscreen(): void {
  const container =
    document.querySelector('.container') ||
    document.querySelector('.test-container');

  if (container && container.requestFullscreen) {
    container.requestFullscreen();
  } else if (document.documentElement.requestFullscreen) {
    document.documentElement.requestFullscreen();
  }
}

/**
 * Exits fullscreen mode with cross-browser compatibility.
 */
export function exitFullscreen(): void {
  if (document.fullscreenElement) {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (
      (document as unknown as { webkitExitFullscreen?: () => void })
        .webkitExitFullscreen
    ) {
      (
        document as unknown as { webkitExitFullscreen: () => void }
      ).webkitExitFullscreen();
    } else if (
      (document as unknown as { mozCancelFullScreen?: () => void })
        .mozCancelFullScreen
    ) {
      (
        document as unknown as { mozCancelFullScreen: () => void }
      ).mozCancelFullScreen();
    } else if (
      (document as unknown as { msExitFullscreen?: () => void })
        .msExitFullscreen
    ) {
      (
        document as unknown as { msExitFullscreen: () => void }
      ).msExitFullscreen();
    }
  }
}
